import React from 'react'
import { useTranslation } from 'react-i18next'
import LanguageSelect from './LanguageSelect'
import { legalLinks } from '../constants/legal-links.ts'

const Footer = () => {
  const { t, i18n } = useTranslation()
  const legal = legalLinks(i18n.language)

  return (
    <footer className="flex items-center justify-between px-6 py-3 text-xs text-muted-foreground border-t border-border">
      <div className="flex items-center gap-3">
        <a className="text-muted-foreground no-underline hover:text-foreground transition-colors" href="mailto:info@urkla.com">
          {t('Footer_support')}
        </a>
        <span className="text-border">·</span>
        <a className="text-muted-foreground no-underline hover:text-foreground transition-colors" href="mailto:info@urkla.com">
          {t('Footer_help_center')}
        </a>
        <span className="text-border">·</span>
        <a
          className="text-muted-foreground no-underline hover:text-foreground transition-colors"
          href={legal.privacy}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('Footer_privacy')}
        </a>
        <span className="text-border">·</span>
        <a
          className="text-muted-foreground no-underline hover:text-foreground transition-colors"
          href={legal.terms}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('Footer_terms_of_service')}
        </a>
      </div>
      <div className="flex items-center gap-3">
        <LanguageSelect />
        <span>© {new Date().getFullYear()} Urkla</span>
      </div>
    </footer>
  )
}
export default Footer
